import script from "./SupportTickets.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportTickets.vue?vue&type=script&lang=ts&setup=true"

import "./SupportTickets.vue?vue&type=style&index=0&id=d96258b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d96258b4"]])

export default __exports__